import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { get } from "lodash";
import $ from "jquery";

import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";

import { setBreadcrumb as setBreadcrumbs } from "../../actions/common";


const styles = {
  idpContent: {
    width: "calc(100vw - 113px)",
    height: "calc(100vh - 148px)",
    minHeight: 0,
    margin: "24px",
    padding: "24px",
  },
};

const Zone = (props) => {
  const { solutionsAccess, classes, dispatch } = props;

  React.useEffect(() => {
    // Fired once on page load.

    // Need to fill the content div with the results of a jquery command here.
    // the id of the div in question is: "idp-content"
    let url = get(solutionsAccess, ["IDP", "url"]);
    console.log("Loading the IDP content: " + url);
    $("#idp-content").load(url);

    buildBreadcrumbs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function buildBreadcrumbs() {
    let breadcrumb = [
      {
        name: "idp",
        display: false,
      },
      {
        name: I18n.get("topbar_idp"),
      },
    ];
    dispatch(setBreadcrumbs(breadcrumb));
  }

  return (
    <Grid
      container
      className={`mainContent ${classes.idpContent}`}
    >
      <div id="idp-content"></div>
    </Grid>
  );
};

const mapStateToProps = (state) => {
  return {
    language: get(state, ["user", "language"]),
    solutionsAccess: get(state, ["user", "solutionsAccess"]),
  };
};

export default withRouter(
  connect(mapStateToProps)(withStyles(styles)(Zone))
);
